import React, { useEffect, useRef } from "react";
import { json, Link, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  setfeedbackPopup,
  setsidebarActive,
} from "../../redux/features/stylesSlice";
import ButtonIcon from "../../components/button/ButtonIcon";
import MenuIcon from "@mui/icons-material/Menu";
import ChatBubbleOutlineIcon from "@mui/icons-material/ChatBubbleOutline";
import DragIndicatorRoundedIcon from "@mui/icons-material/DragIndicatorRounded";
import VisibilityRoundedIcon from "@mui/icons-material/VisibilityRounded";
import VisibilityOffRoundedIcon from "@mui/icons-material/VisibilityOffRounded";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { sidebarIcons } from "../data/sidebarData";
import { sethiddenNews, setsidebarData } from "../../redux/features/dataSlice";
import { getConfig, searchAPI } from "../../apis";
import { Tooltip } from "@mui/material";
import { logEvent } from "../../functions/amplitude";
import { axiosInstance } from "../../functions/axios";

const SidebarOpen = () => {
  const dispatch = useDispatch();
  const { pathname } = useLocation();

  const initialRenderSidebar = useRef(true);
  const { sidebarActive } = useSelector((state) => state.styles);

  const { user } = useSelector((state) => state.auth);

  const { sidebarData, hiddenNews } = useSelector((state) => state.data);

  const hasWindow = typeof window !== "undefined";

  async function updateCategory(data) {
    await axiosInstance.post(
      searchAPI.updateSidebar,
      {
        listOfCategories: data,
        callingUserId: user.userId,
        userId: user.userId,
      },
      getConfig()
    );
  }

  useEffect(() => {
    if (initialRenderSidebar.current) {
      initialRenderSidebar.current = false;
    } else {
      const windowWidth = hasWindow ? window.innerWidth : null;
      windowWidth < 600 && dispatch(setsidebarActive(false));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  async function onDragEnd(res) {
    if (!res.destination) return;
    const sourceIndex = res.source.index;
    const destinationIndex = res.destination.index;

    const sidebarDataCopy = JSON.parse(JSON.stringify(sidebarData));

    let [selectedRow] = sidebarDataCopy.splice(sourceIndex, 1);
    sidebarDataCopy.splice(destinationIndex, 0, selectedRow);

    dispatch(setsidebarData(sidebarDataCopy));

    await updateCategory(sidebarDataCopy);
  }

  return (
    <div className={`sidebar-open ${sidebarActive ? "sidebar-active" : ""}`}>
      <div className="wrapper">
        <ButtonIcon
          onClick={() => dispatch(setsidebarActive(false))}
          className="hd-mb"
        >
          <MenuIcon />
        </ButtonIcon>
        <div className="menu">
          <DragDropContext onDragEnd={onDragEnd}>
            <Droppable droppableId="sidebarId">
              {(provided, snapshot) => (
                <div
                  className="section"
                  {...provided.droppableProps}
                  ref={provided.innerRef}
                >
                  {sidebarData.map((item, i) => (
                    <Draggable
                      key={item.categoryName_chr}
                      draggableId={item.categoryName_chr}
                      index={i}
                    >
                      {(provided, snapshot) => (
                        <div
                          className={`tab ${false ? "tab-active" : ""}`}
                          ref={provided.innerRef}
                          {...provided.draggableProps}
                        >
                          <div className="drag-wrapper">
                            <div className="drag" {...provided.dragHandleProps}>
                              <Tooltip title="Drag to reorder">
                                <DragIndicatorRoundedIcon />
                              </Tooltip>
                            </div>
                          </div>
                          <div
                            className="flex"
                            onClick={() => {
                              const el = document.getElementById(
                                item.categoryName_chr
                              );
                              el.scrollIntoView({
                                behavior: "smooth",
                                block: "center",
                                inline: "center",
                              });
                            }}
                          >
                            <div className="icon">
                              {sidebarIcons[item.categoryName_chr]}
                            </div>
                            <p>{item.categoryName_chr}</p>
                          </div>
                          <div
                            className={`eye-icon ${
                              item.isHidden_ysn ? "visible" : ""
                            }`}
                            onClick={async () => {
                              const sidebarDataCopy = JSON.parse(
                                JSON.stringify(sidebarData)
                              );
                              sidebarDataCopy[i].isHidden_ysn =
                                !item.isHidden_ysn;
                              dispatch(setsidebarData(sidebarDataCopy));
                              await updateCategory(sidebarDataCopy);
                            }}
                          >
                            {item.isHidden_ysn ? (
                              <Tooltip title="Hide category">
                                <VisibilityOffRoundedIcon />
                              </Tooltip>
                            ) : (
                              <Tooltip title="Hide category">
                                <VisibilityRoundedIcon />
                              </Tooltip>
                            )}
                          </div>
                        </div>
                      )}
                    </Draggable>
                  ))}
                  {provided.placeholder}
                </div>
              )}
            </Droppable>
          </DragDropContext>
        </div>

        <div className="feedback-tab">
          <div
            className={`tab ${pathname === "/settings" ? "tab-active" : ""}`}
            onClick={() => {
              dispatch(setfeedbackPopup(true));
              logEvent("click_footer_feedback", { feedback: "clicked" });
            }}
          >
            <div className="icon">
              <ChatBubbleOutlineIcon />
            </div>
            <p>Feedback</p>
          </div>
        </div>
      </div>
      <div className="" onClick={() => dispatch(setsidebarActive(false))} />
    </div>
  );
};

export default SidebarOpen;
